<template>
  <div class="customer-service">
    <div class="form">
      <div class="form-item">
        <div class="label">门店ID</div>
        <div class="value"><el-input size="medium" v-model="form.wb_id" placeholder="请输入门店ID"></el-input></div>
      </div>
      <div class="form-item">
        <div class="label">门店账号</div>
        <div class="value"><el-input size="medium" v-model="form.account" placeholder="请输入门店账号"></el-input></div>
      </div>
    </div>
    <div class="qrcode-btn" v-if="queryWb!=`${form.wb_id||''}-${form.account}`" @click="submitQrcode" v-loading="loading">提 交</div>
    <div v-if="qrcode_url" class="qrcode_url">
      <el-image
        style="width: 100%"
        :src="qrcode_url"
        fit="scale-down"
      />
      <div class="qrcode-tips">长按添加专属微信客服</div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { baseURL } from "@/util/config";

export default {
  name: "customerService",
  data() {
    return {
      url: baseURL,
      form: {
        wb_id: "",
        account: ""
      },
      qrcode_url: '',
      loading: false,
      touchStartTime: 0,
      isLongPressing: false,
      queryWb:'',
    };
  },
  methods: {
    async submitQrcode() {
      if (this.loading) return;
      this.loading = true;

      const { wb_id, account } = this.form;
      if (!wb_id && !account) {
        this.$message.error('请输入门店ID或账号');
        this.loading = false;
        return;
      }

      try {
        this.qrcode_url=''
        this.queryWb = `${wb_id||''}-${account||''}`
        const response = await axios.get(`${this.url}/mobile/customerService/getCustomerServiceWechatQrCode`, {
          params: { wb_id, account }
        });
        if (response.data.code === 0) {
          this.qrcode_url = response.data.data.qrcode_url;
        } else {
          this.$message.error(response.data.msg || '获取二维码失败');
        }
      } catch (error) {
        console.error('获取二维码失败:', error);
        this.$message.error('获取二维码失败，请稍后再试');
      } finally {
        this.loading = false;
      }
    },
  },
  beforeCreate() {
    document.title='云购客服'
  }
};
</script>

<style scoped>
.customer-service {
  padding: 12px;
  height: 100vh;
  box-sizing: border-box;
  background: #F6F6F6;
}

.customer-service .form-item {
  display: flex;
  align-items: center;
  width: 100%;
  box-sizing: border-box;
  background: #FFFFFF;
  border-radius: 8px;
  padding: 10px;
  margin-bottom: 12px;
}

.customer-service .label {
  min-width: 80px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 600;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.85);
}

.customer-service .value {
  flex: 1;
}

.qrcode_url {
  width: 90%;
  min-height: 90vw;
  margin: 0 auto;
  margin-top: 20px;
  transition: all .3s;
}

.qrcode-tips{
  text-align: center;
  padding: 10px 0;
  font-size: 16px;
  color: #333;
}

.qrcode-btn {
  /* position: fixed; */
  /* bottom: 30px; */
  /* left: 15px; */
  /* right: 15px; */
  box-sizing: border-box;
  background: linear-gradient(135deg, #FF827B 0%, #FE6259 100%);
  border-radius: 25px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  font-size: 18px;
  color: #FFFFFF;
  line-height: 25px;
  padding: 12px 0;
  text-align: center;
  z-index: 999;
}
</style>



// WEBPACK FOOTER //
// src/views/customerService/index.vue